import Model from "./base/model";

class ConfigurationsAudit extends Model {
  resourceName() {
    return "configurations_audit";
  }

  fields() {
    return {
      company_id: "",
      audit: "",
      value: "",
     
      company: { jsonApi: "hasOne", type: "companies"},
      
    };
  }

  async storeConfigurationsAudit(data) {
    return this.request(
      "shippers/configurations_audit",
      "POST",
      {},
      data
    );
  }

  async updateConfigurationsAudit(id, data) {
    return this.request(
      `shippers/configurations_audit/${id}`,
      "PATCH",
      {},
      data
    );
  }

}

export default new ConfigurationsAudit();
